import { use } from 'react';
import { twMerge } from 'tailwind-merge';

import { FormContext } from './FormContext';

interface Props {
  className?: string;
}

export function SubmissionError(props: Props) {
  const { error } = use(FormContext);

  if (error) {
    return (
      <div
        className={twMerge(
          'absolute',
          'top-full',
          'translate-y-1',
          'text-xs',
          'text-rose-500',
          'text-center',
          'w-full',
          props.className,
        )}
      >
        {error}
      </div>
    );
  }

  return null;
}
